module.exports = __webpack_public_path__ + "static/img/role.abe9e58.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/u/role.png
// module id = fJtn
// module chunks = 7